<template>
  <div>
    <div class="columns is-multiline">
      <div
        v-if="selectedProduct"
        class="column is-12-mobile is-8-tablet is-offset-2-tablet is-4-desktop is-offset-4-desktop"
      >
        <div class="general-container">
          <div class="coin-count">
            <img src="@/assets/img/coin.svg" alt="Coin Icon" />
            {{ selectedProduct.amount }}
          </div>
          <div class="price-container">
            <div
              class="old-price"
              v-if="selectedProduct.stripe_price.original_price"
            >
              {{
                currencies[selectedProduct.stripe_price.currency.toUpperCase()]
              }}{{ selectedProduct.stripe_price.original_price }}
            </div>
            <div class="current-price">
              {{
                currencies[selectedProduct.stripe_price.currency.toUpperCase()]
              }}{{ selectedProduct.stripe_price.price }}
            </div>
          </div>
          <div class="col-12 pb-0">
            <label>{{ $t("labels.email") }}*</label>
            <div class="input-container">
              <input
                name="email"
                id="email"
                v-model="email"
                :placeholder="$t('labels.email')"
              />
            </div>
            <div
              class="validation-error-message m-0 p-0"
              v-if="validation.firstError('email')"
            >
              {{ validation.firstError("email") }}
            </div>
            <button
              @click="connectEmail"
              class="button custom-button orange-button"
              :disabled="loading || !email"
            >
              {{ $t("labels.continue") }}
              <img
                src="@/assets/img/loading.svg"
                alt="loading"
                class="loading"
                v-if="loading"
              />
            </button>
          </div>
          <div class="col-12 p-0" v-if="!isHybridPage">
            <div class="has-text-centered mb-3">{{ $t("login_page.or") }}</div>
            <div id="googleSignIn" class="google-sign-in btn-sign-in"></div>
          </div>
          <div class="col-12">
            <div class="card-error" v-if="connectError">
              {{ this.connectError }}
            </div>
          </div>
          <div
            class="checkout-badge"
            v-if="
              selectedProduct.stripe_price.original_price &&
              selectedProduct.stripe_price.discount
            "
          >
            %{{ selectedProduct.stripe_price.discount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/components/Payment/Stripe/GetEmail.scss";
</style>
<script>
"use strict";
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;
import { mapState, mapActions } from "vuex";

const endpoints = require("@/api/endpoints");

export default {
  name: "GetEmail",
  data() {
    return {
      loading: false,
      connectError: null,
      email: null,
    };
  },
  computed: {
    ...mapState({
      isHybridPage: (state) => state.client.isHybridPage,
      selectedProduct: (state) => state.payment.selectedProduct,
      currencies: (state) => state.client.currencies,
      buyCoinBackground: (state) => state.client.buyCoinBackground,
    }),
  },
  validators: {
    email: function (value) {
      return Validator.value(value).required().email();
    },
  },
  mounted() {
    window["backButtonTapped"] = () => {
      if (confirm(this.$t("labels.close_confirm"))) {
        this.hybridClose("close");
        return "close";
      }
      return "nothing";
    };
    this.$hybridapi("updateWindowSize", "medium");
    this.$hybridapi("hideLoading");
    this.$hybridapi("updatePageTitle", this.$t("labels.do_payment"));

    if (this.buyCoinBackground !== "black-opac-bg") {
      this.$store.dispatch("client/setBuyCoinBackground", "white-bg");
    }

    if (!this.selectedProduct) {
      this.hybridClose("close");
      this.$store.dispatch("payment/setStripeActivePage", "coinSelect");
    }

    //google sign-in
    this.$gAuth.load(this.onGoogleSignInSuccess, this.onGoogleSignInFail, 200);
  },
  methods: {
    ...mapActions("payment", ["postHybridCloseChecks"]),
    connectEmail() {
      this.$validate().then((success) => {
        if (success) {
          this.loading = true;
          endpoints
            .connect_email(this.$axios, { email: this.email })
            .then((connectEmailResponse) => {
              connectEmailResponse = connectEmailResponse.data;
              this.loading = false;
              if (connectEmailResponse.error) {
                this.connectError = connectEmailResponse.error.message;
              } else if (connectEmailResponse.success) {
                this.$store.dispatch("payment/setStripeActivePage", "checkout");
              }
            })
            .catch(() => {
              this.loading = false;
              this.connectError = this.$t("errors.general_error");
            });
        }
      });
    },
    removeError() {
      this.connectError = null;
    },
    onGoogleSignInSuccess(response) {
      let google_id_token = response.credential;
      endpoints
        .connect_google(this.$axios, { token: google_id_token })
        .then((googleConnectResponse) => {
          this.loading = false;
          googleConnectResponse = googleConnectResponse.data;
          if (googleConnectResponse.error) {
            this.connectError = googleConnectResponse.error.message;
          } else if (googleConnectResponse.success) {
            //  Successfully connected
            this.$store.dispatch("payment/setStripeActivePage", "checkout");
          }
        })
        .catch(() => {
          this.loading = false;
          this.connectError = this.$i18n.t("errors.general_error");
        });
    },
    onGoogleSignInFail() {
      this.loading = false;
      this.connectError = this.$i18n.t("errors.general_error");
    },
    hybridClose(exit_location = "close") {
      this.$hybridapi("close", exit_location);
      if (this.isHybridPage) this.postHybridCloseChecks();
    },
  },
};
</script>
